export class AlternateEventTypeGroupMap {
    constructor(alternateEventTypeGroupMapIdentity: number, eventTypeGroupId: number, initialExcludeEventTypeGroupId: number | null) {
        this.alternateEventTypeGroupMapIdentity = alternateEventTypeGroupMapIdentity;
        this.eventTypeGroupId = eventTypeGroupId;
        this.initialExcludeEventTypeGroupId = initialExcludeEventTypeGroupId;
    }
    alternateEventTypeGroupMapIdentity: number;
    eventTypeGroupId: number;
    initialExcludeEventTypeGroupId: number | null;
}
